export default {
    label: 'Enabled',
    description: 'Disable or Enable rule',
    key: 'enabled',
    type: 'checkbox'
};
